'use client';

import { useCallback, useState } from 'react';

export const useBlockDoubleTap = (callback: () => void, delay = 300) => {
  const [isBlocked, setIsBlocked] = useState(false);

  return useCallback(() => {
    if (!isBlocked) {
      callback();
      setIsBlocked(true);
      setTimeout(() => setIsBlocked(false), delay);
    }
  }, [callback, isBlocked, delay]);
};
